import { render, staticRenderFns } from "./ArticleWithNav.vue?vue&type=template&id=68f238ce&scoped=true&"
import script from "./ArticleWithNav.vue?vue&type=script&lang=js&"
export * from "./ArticleWithNav.vue?vue&type=script&lang=js&"
import style0 from "./ArticleWithNav.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArticleWithNav.vue?vue&type=style&index=1&id=68f238ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f238ce",
  null
  
)

export default component.exports